// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabSelectorContainer {
  display: flex;
  flex-direction: row;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  justify-content: space-evenly;
}
@media (max-width: 1350px) {
  .tabSelectorContainer {
    padding: 6px;
  }
}
@media (max-width: 1000px) {
  .tabSelectorContainer {
    width: 100%;
  }
}

.tabSelectorOptionBase, .tabSelectorOptionSelected, .tabSelectorOptionAvailable {
  width: 100%;
  font-family: Bai Jamjuree;
  font-weight: 500;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media (max-width: 1400px) {
  .tabSelectorOptionBase, .tabSelectorOptionSelected, .tabSelectorOptionAvailable {
    padding: 8px;
  }
}
@media (max-width: 1350px) {
  .tabSelectorOptionBase, .tabSelectorOptionSelected, .tabSelectorOptionAvailable {
    padding: 8px 6px;
  }
}
@media (max-width: 1000px) {
  .tabSelectorOptionBase, .tabSelectorOptionSelected, .tabSelectorOptionAvailable {
    font-size: 14px;
  }
}
@media (max-width: 420px) {
  .tabSelectorOptionBase, .tabSelectorOptionSelected, .tabSelectorOptionAvailable {
    min-width: 90px;
  }
}
@media (max-width: 380px) {
  .tabSelectorOptionBase, .tabSelectorOptionSelected, .tabSelectorOptionAvailable {
    font-size: 13px;
  }
}

.tabSelectorOptionAvailable {
  color: rgba(255, 255, 255, 0.5019607843);
  cursor: pointer;
}
.tabSelectorOptionAvailable:hover {
  color: #FFFFFF;
  background-color: rgba(69, 174, 255, 0.1);
  border-color: rgba(69, 174, 255, 0.1);
}

.tabSelectorOptionSelected {
  border-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%);
  border-image-slice: 1;
  border-image-width: 1;
  border-image-outset: 0;
  border-image-repeat: stretch;
  background-color: rgba(69, 174, 255, 0.2);
  color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/Components/TabSelector/TabSelector.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0CAAA;EACA,8BAAA;EACA,kBAAA;EACA,6BAAA;AACD;AAAC;EARD;IASE,YAAA;EAGA;AACF;AAFC;EAXD;IAYE,WAAA;EAKA;AACF;;AADA;EACC,WAAA;EAEA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAGD;AAFC;EAfD;IAgBE,YAAA;EAKA;AACF;AAJC;EAlBD;IAmBE,gBAAA;EAOA;AACF;AANC;EArBD;IAsBE,eAAA;EASA;AACF;AARC;EAxBD;IAyBE,eAAA;EAWA;AACF;AAVC;EA3BD;IA4BE,eAAA;EAaA;AACF;;AAVA;EAEC,wCAAA;EACA,eAAA;AAYD;AAXC;EACC,cAAA;EACA,yCAAA;EACA,qCAAA;AAaF;;AARA;EAEC,sFAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yCAAA;EACA,cAAA;AAUD","sourcesContent":[".tabSelectorContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tpadding: 8px;\r\n\tborder: 1px solid #FFFFFF33;\r\n\tbackground: rgba(0, 0, 0, 0.7);\r\n\tborder-radius: 2px;\r\n\tjustify-content: space-evenly;\r\n\t@media (max-width: 1350px) {\r\n\t\tpadding: 6px;\r\n\t}\r\n\t@media (max-width:1000px) {\r\n\t\twidth: 100%;\r\n\t}\r\n}\r\n\r\n\r\n.tabSelectorOptionBase {\r\n\twidth: 100%;\r\n\r\n\tfont-family: Bai Jamjuree;\r\n\tfont-weight: 500;\r\n\tfont-size: 16px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tpadding: 8px 16px;\r\n\tborder: 1px solid transparent;\r\n\ttransition: all 0.2s ease-in-out;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\t@media (max-width: 1400px) {\r\n\t\tpadding: 8px;\r\n\t}\r\n\t@media (max-width: 1350px) {\r\n\t\tpadding: 8px 6px;\r\n\t}\r\n\t@media (max-width:1000px) {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t@media (max-width: 420px) {\r\n\t\tmin-width: 90px;\r\n\t}\r\n\t@media (max-width: 380px) {\r\n\t\tfont-size: 13px;\r\n\t}\r\n}\r\n\r\n.tabSelectorOptionAvailable  {\r\n\t@extend .tabSelectorOptionBase;\r\n\tcolor: #FFFFFF80;\r\n\tcursor: pointer;\r\n\t&:hover {\r\n\t\tcolor: #FFFFFF;\r\n\t\tbackground-color: rgba(69, 174, 255, 0.1);\r\n\t\tborder-color: rgba(69, 174, 255, 0.1);\r\n\t}\r\n}\r\n\r\n\r\n.tabSelectorOptionSelected {\r\n\t@extend .tabSelectorOptionBase;\r\n\tborder-image-source: linear-gradient(93.94deg, #45AEFF 0%, rgba(41, 104, 153, 0) 100%);\r\n\tborder-image-slice: 1;\r\n\tborder-image-width: 1;\r\n\tborder-image-outset: 0;\r\n\tborder-image-repeat: stretch;\r\n\tbackground-color: #45AEFF33;\r\n\tcolor: #FFFFFF;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
